// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__qncLS","banner":"index_banner__9B0_6","search":"index_search__j73_s","input_box":"index_input_box__lMlOy","btn":"index_btn__zEBzE"};